import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { Transition } from '@uirouter/angular';
import { ErrorComponent } from './error/error.component';
import { STATE_ACCESS, STATE_CREATETICKET, STATE_ERROR_AUTHENTICATED, STATE_ERROR_UNAUTHENTICATED, STATE_FORGOT_PASSWORD, STATE_LOGIN, STATE_RESET_PASSWORD, STATE_SIGNUP } from '../shared/app-states';
import { AccessComponent } from './access.component';
import { LoginComponent } from './login/login.component';
import { CommonModule } from '@angular/common';
import { AccessDataService } from './access-data.service';
import { SignupComponent } from './signup/signup.component';
import { ReturnToLoginComponent } from './snippets/return-to-login.component';
import { NoEmailReceivedComponent } from './snippets/no-email-received.component';
import { CreateTicketComponent } from './createticket/create-ticket.component';
import { ResetPasswordComponent } from './password/reset-password.component';
import { ForgotPasswordComponent } from './password/forgot-password.component';
import { TranslationHelperService } from '../shared/translation/translation-helper.service';
import { GaStateDeclaration } from '../../type_definitions/datatypes';
import { UrlService } from '../shared/browser/url.service';
import * as _ from 'underscore';

export const states:GaStateDeclaration[] = [
  {
    name: STATE_ACCESS,
    url: '?theme',
    params: {
      theme: { dynamic: true }
    },
    views: {
      main: {
        component: AccessComponent
      }
    },
    resolve: [
      {
        token: 'translateReady',
        deps: [ TranslationHelperService ],
        resolveFn: (translationHelperService:TranslationHelperService) => translationHelperService.onReady()
      }
    ],
    data: {
      translate: true
    },
    abstract: true
  },
  {
    name: STATE_LOGIN,
    url: '/login?as',
    component: LoginComponent,
    resolve: [
      {
        token: 'loginAs',
        deps: [ UrlService ],
        resolveFn: (urlService:UrlService):string => {
          if (_.has(urlService.urlParams, 'as')) {
            return urlService.urlParams?.as || 'true';
          }
        }
      }
    ]
  },
  {
    name: STATE_SIGNUP,
    url: '/signup/{company}?context',
    component: SignupComponent,
    params: {
      company: {
        value: null
      }
    }
  },
  {
    name: STATE_ERROR_UNAUTHENTICATED,
    url: '/error?errorMessage',
    component: ErrorComponent,
    resolve: [
      {
        token: 'errorMessage',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.errorMessage
      }
    ]
  },
  {
    name: STATE_ERROR_AUTHENTICATED,
    url: '/error',
    component: ErrorComponent,
    resolve: [
      {
        token: 'invalidUrl',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.invalidUrl
      }
    ],
    bindings: {
      invalidUrl: 'invalidUrl'
    },
    params: {
      invalidUrl: { value: null }
    }
  },
  {
    name: STATE_CREATETICKET,
    url: '/createticket/{company}?context&requestType',
    component: CreateTicketComponent,
    resolve: [
      {
        token: 'context',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.context
      },
      {
        token: 'requestType',
        deps: [ Transition ],
        resolveFn: (transition:Transition) => transition.params()?.requestType
      }
    ]
  },
  {
    name: STATE_FORGOT_PASSWORD,
    url: '/forgot-password',
    component: ForgotPasswordComponent
  },
  {
    name: STATE_RESET_PASSWORD,
    url: '/reset-password?token',
    component: ResetPasswordComponent
  }
];

@NgModule({
  declarations: [
    AccessComponent,
    ErrorComponent,
    LoginComponent,
    SignupComponent,
    CreateTicketComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    ReturnToLoginComponent,
    NoEmailReceivedComponent
  ],
  imports: [
    CommonModule,
    UIRouterModule.forChild({ states }),
    SharedModule
  ],
  providers: [
    AccessDataService
  ]
})
export class AccessModule {
}